import * as _ from "lodash"
import {IHierarchyRelationship, IHierarchyStructure, INode} from "../PA.MD.Core/PA.MD.IF.Hierarchy";

//-- Generic Hierarchy relationship for use in in-memory only HierarchyStructures
//--  i.e. Reading a Current/ Full Hierarchy from the ODS

export class GenericRelation
    implements IHierarchyRelationship
{
    private _hierStructure: IHierarchyStructure

    private _child: INode;
    private _parent: INode;
    private _effectiveStartDt: Date;
    private _effectiveEndDt: Date;

    private _bDelete: boolean

    constructor(structure: IHierarchyStructure, clone?: IHierarchyRelationship) {
        this._hierStructure = structure
        this._bDelete = false
        this._child = undefined
        this._parent = undefined
        this._effectiveStartDt = undefined
        this._effectiveEndDt = undefined
        if(!_.isEmpty(clone)){
            this._child = clone.child
            this._parent = clone.parent
            this._effectiveStartDt = clone.effectiveStartDt
            this._effectiveEndDt = clone.effectiveEndDt
        }
    }

    get hierarchy(): IHierarchyStructure { return this._hierStructure }

    get child(): INode { return this._child }
    get parent(): INode { return this._parent }
    get effectiveStartDt(): Date { return  this._effectiveStartDt }
    get effectiveEndDt(): Date { return this._effectiveEndDt  }

    get isActive(): boolean {
        return !this._bDelete
    }
    get isActiveNew(): boolean {
        return !this._bDelete
    }

    get isModified(): boolean {
            return false
    }


    setChild(aNode: INode): void {
        this._child = aNode
    }
    setParent(aNode: INode): void {
        this._parent = aNode
    }
    setEffectiveStartDt(aDate: Date): void {
        this._effectiveStartDt = aDate
    }
    setEffectiveEndDt(aDate: Date): void {
        this._effectiveEndDt = aDate
    }


    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        // This should never be called
    }




}